export const UPDATE_SYSTEM_STATUS = 'systemStatus/UPDATE_SYSTEM_STATUS';
export const updateSystemStatus = (status: any) => ({
  type: UPDATE_SYSTEM_STATUS,
  status,
});
